import React from "react"

const AnggotaTimja = React.lazy(() => import('./AnggotaTimja'))
const DetailTimja = React.lazy(() => import('./AnggotaTimja/DetailTimja'))

export const manajemenConfigs = [
    {
        path: '/manajemen/anggota-tim-kerja',
        element: <AnggotaTimja />,
        permittedRole: ['Administrator', 'Operator', 'Viewer', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360']
    },
    {
        path: '/manajemen/anggota-tim-kerja/detail/:id',
        element: <DetailTimja />,
        permittedRole: ['Administrator', 'Operator', 'Viewer', 'Admin Penilaian 360', 'Operator Penilaian 360', 'Operator Eselon 1 Penilaian 360']
    }
]
